import { http } from '@utils/index';

const getAll = () => {
	return http.get<APIResponse<SaChaptersRes[]>>(`/sa/chapters?per_page=-1`);
};
export default getAll;
